var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTweter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_406_2133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5107 3.71265C14.9476 3.95713 14.3519 4.1182 13.7422 4.19077C14.3829 3.81589 14.8647 3.22033 15.0973 2.51578C14.4915 2.86971 13.83 3.11805 13.1409 3.25015C12.8507 2.94625 12.5017 2.7045 12.1151 2.53957C11.7285 2.37465 11.3124 2.29 10.8921 2.29078C9.19024 2.29078 7.81302 3.64702 7.81302 5.31889C7.81181 5.55144 7.83848 5.7833 7.89245 6.00952C6.67211 5.95235 5.47714 5.64126 4.38401 5.09616C3.29087 4.55106 2.32364 3.78395 1.54418 2.8439C1.27073 3.30456 1.12611 3.83016 1.12544 4.36577C1.12544 5.41577 1.67365 6.34389 2.50142 6.88764C2.01099 6.87601 1.53061 6.74629 1.10105 6.50951V6.54701C1.10105 8.01576 2.16431 9.23763 3.57156 9.51575C3.30693 9.58625 3.03423 9.62197 2.76036 9.622C2.56603 9.62234 2.37213 9.6035 2.18151 9.56575C2.57272 10.7689 3.71135 11.6439 5.06012 11.6689C3.96415 12.5129 2.61858 12.9691 1.2349 12.9657C0.989291 12.9654 0.743913 12.9508 0.5 12.922C1.90762 13.8202 3.54387 14.2953 5.21398 14.2907C10.8855 14.2907 13.984 9.67513 13.984 5.67202C13.984 5.54077 13.9805 5.40952 13.9743 5.28139C14.5757 4.85391 15.0959 4.32268 15.5107 3.71265Z",
    fill: "#4E944F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_406_2133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.290771)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTweter);
export default __webpack_public_path__ + "static/media/tweter.2351842887ea44c979482be2392e9232.svg";
export { ForwardRef as ReactComponent };